import { FC } from 'react';

import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';

export interface Props {
  actionTitle?: string;
  attemptedAction?: string;
  message?: string;
  onActionButtonClick?: () => void;
  title?: string;
}

export const ErrorBox: FC<Props> = ({
  actionTitle,
  attemptedAction,
  message,
  onActionButtonClick,
  title,
}) => {
  const msg = `Error occurred when trying to ${attemptedAction}.`;

  return (
    <Box padding={3} textAlign="center" width="100%">
      <Typography marginBottom={2} variant="h5">
        {title ?? 'Something went wrong'}
      </Typography>
      <Typography marginBottom={onActionButtonClick ? 4 : 0} variant="body1" whiteSpace="pre-line">
        {message || msg}
      </Typography>
      {!!onActionButtonClick && (
        <Button onClick={onActionButtonClick} variant="contained">
          {actionTitle || 'Try again'}
        </Button>
      )}
    </Box>
  );
};
